import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "frame" }
const _hoisted_3 = { class: "frame__inner" }
const _hoisted_4 = { class: "frame__header" }
const _hoisted_5 = { class: "frame__body" }
const _hoisted_6 = { class: "sim-remittances" }
const _hoisted_7 = { class: "sim-remittances__inner" }
const _hoisted_8 = { class: "sim-remittances__phone" }
const _hoisted_9 = { class: "sim-remittances__sum" }
const _hoisted_10 = { class: "sim-remittances__payment" }
const _hoisted_11 = { class: "payment" }
const _hoisted_12 = { class: "payment__inner" }
const _hoisted_13 = { class: "payment__header" }
const _hoisted_14 = { class: "payment__title" }
const _hoisted_15 = { class: "payment__picker" }
const _hoisted_16 = { class: "payment__card" }
const _hoisted_17 = { class: "payment__body" }
const _hoisted_18 = {
  key: 0,
  class: "payment__card-form"
}
const _hoisted_19 = { class: "card-form__item" }
const _hoisted_20 = { class: "card-form__item" }
const _hoisted_21 = { class: "card-form__item" }
const _hoisted_22 = { class: "card-form__item" }
const _hoisted_23 = {
  key: 0,
  class: "js-sdk-error"
}
const _hoisted_24 = {
  key: 1,
  class: "payment__phone"
}
const _hoisted_25 = { class: "sim-remittances__total" }
const _hoisted_26 = { class: "total" }
const _hoisted_27 = { class: "total__item" }
const _hoisted_28 = { class: "total__text" }
const _hoisted_29 = { class: "total__number" }
const _hoisted_30 = { class: "total__item" }
const _hoisted_31 = { class: "total__text" }
const _hoisted_32 = { class: "total__number" }
const _hoisted_33 = { class: "sim-remittances__btn" }
const _hoisted_34 = { class: "button__loader" }
const _hoisted_35 = {
  key: 0,
  class: "spinner"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Back = _resolveComponent("Back")!
  const _component_ap_input_tel = _resolveComponent("ap-input-tel")!
  const _component_ap_input_money = _resolveComponent("ap-input-money")!
  const _component_ap_radio = _resolveComponent("ap-radio")!
  const _component_ap_input_mask = _resolveComponent("ap-input-mask")!
  const _component_ap_input = _resolveComponent("ap-input")!
  const _component_ap_button = _resolveComponent("ap-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Back, {
            title: _ctx.$t('replenish_the_balance'),
            redirect: _ctx.redirect
          }, null, 8, ["title", "redirect"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ap_input_tel, {
                  id: "receiver",
                  modelValue: _ctx.payee.recipient,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payee.recipient) = $event)),
                  label: _ctx.$t('sim_remittances.recipient'),
                  "icon-name": _ctx.receiverOperator,
                  disabled: "",
                  onInput: _ctx.keyup
                }, null, 8, ["modelValue", "label", "icon-name", "onInput"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ap_input_money, {
                  modelValue: _ctx.payee.sum,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payee.sum) = $event)),
                  label: _ctx.$t('amount'),
                  currency: "",
                  "error-text": _ctx.refillError.amount,
                  onKeyup: _ctx.changeSum
                }, null, 8, ["modelValue", "label", "error-text", "onKeyup"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t('from')), 1),
                        _createElementVNode("div", _hoisted_15, [
                          (_ctx.cardPaymentEnable)
                            ? (_openBlock(), _createBlock(_component_ap_radio, _mergeProps({
                                key: 0,
                                id: "card",
                                text: _ctx.$t('bank_card'),
                                checked: _ctx.currentPaymentMethodCard,
                                "icon-name": "paymentCard.svg"
                              }, _toHandlers(_ctx.cardPaymentEnable && _ctx.simPaymentEnable ? { click: _ctx.switchPayToCard } : {})), null, 16, ["text", "checked"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_16, [
                            (_ctx.simPaymentEnable)
                              ? (_openBlock(), _createBlock(_component_ap_radio, _mergeProps({
                                  key: 0,
                                  id: "sim ",
                                  text: _ctx.$t('mobile_balance'),
                                  checked: !_ctx.currentPaymentMethodCard,
                                  "icon-name": "paymentSim.svg"
                                }, _toHandlers(_ctx.simPaymentEnable  && _ctx.cardPaymentEnable ? { click: _ctx.switchPaymentToSim } : {})), null, 16, ["text", "checked"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        (_ctx.currentPaymentMethod === _ctx.CARD)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("div", {
                                class: _normalizeClass(['card-form', _ctx.JsSDKError.class])
                              }, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_ap_input_mask, {
                                    modelValue: _ctx.cardDetails.number,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cardDetails.number) = $event)),
                                    type: "cardNumber",
                                    full: "",
                                    border: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_ap_input_mask, {
                                    modelValue: _ctx.cardDetails.expDate,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cardDetails.expDate) = $event)),
                                    border: "",
                                    type: "expireDate"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_ap_input, {
                                    modelValue: _ctx.cardDetails.cvv,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cardDetails.cvv) = $event)),
                                    border: "",
                                    type: "cvv",
                                    length: "3",
                                    placeholder: "CVV/CVC"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_ap_input, {
                                    modelValue: _ctx.cardDetails.holderName,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cardDetails.holderName) = $event)),
                                    border: "",
                                    placeholder: _ctx.$t('holder_name')
                                  }, null, 8, ["modelValue", "placeholder"])
                                ])
                              ], 2),
                              (_ctx.JsSDKError)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.JsSDKError.text), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.currentPaymentMethod === _ctx.SIM)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createVNode(_component_ap_input_tel, {
                                id: "sender",
                                modelValue: _ctx.payee.phone,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payee.phone) = $event)),
                                label: _ctx.t('sim_remittances.sim_to_sim_label'),
                                "icon-name": _ctx.senderOperator,
                                "error-text": _ctx.sim2simErrorText,
                                onKeyup: _ctx.keyup
                              }, null, 8, ["modelValue", "label", "icon-name", "error-text", "onKeyup"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('commission')), 1),
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.payee.commission || 0) + " ₸ ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('write_off_amount')), 1),
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.formatNumber(_ctx.payee.total) || 0) + " ₸ ", 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_ap_button, {
                    type: "primary",
                    full: "",
                    disable: _ctx.disabledBtn,
                    onClick: _ctx.pay
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_34, [
                        (_ctx.checking)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                          : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createTextVNode(_toDisplayString(_ctx.$t('replenish')) + " ", 1),
                              (_ctx.payee.amount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.formatNumber(_ctx.payee.amount)) + " ₸", 1))
                                : _createCommentVNode("", true)
                            ]))
                      ])
                    ]),
                    _: 1
                  }, 8, ["disable", "onClick"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}